"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Linkicon = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importDefault(require("react"));

var contents_1 = require("./partials/contents");

var root_1 = require("./styled/root");

var Linkicon = function Linkicon(_a) {
  var __UIScope = _a.__UIScope,
      testID = _a["data-testid"],
      className = _a.className,
      href = _a.href,
      _b = _a.iconScale,
      iconScale = _b === void 0 ? 2 : _b,
      isInverse = _a.isInverse,
      label = _a.label,
      leadingIcon = _a.leadingIcon,
      onClick = _a.onClick,
      _c = _a.pattern,
      pattern = _c === void 0 ? 'primary' : _c,
      _d = _a.scale,
      scale = _d === void 0 ? 5 : _d,
      trailingIcon = _a.trailingIcon,
      isDisabled = _a.isDisabled,
      rest = tslib_1.__rest(_a, ["__UIScope", 'data-testid', "className", "href", "iconScale", "isInverse", "label", "leadingIcon", "onClick", "pattern", "scale", "trailingIcon", "isDisabled"]);

  var rootClasses = (0, ui_helper_deep_branding_1.useEscapeClasses)({
    block: 'Linkicon',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;
  return react_1.default.createElement(react_1.default.Fragment, null, href ? react_1.default.createElement(root_1.Root, tslib_1.__assign({
    className: rootClasses,
    "data-testid": testID,
    isInverse: isInverse,
    pattern: pattern,
    href: href,
    as: "a"
  }, rest), react_1.default.createElement(contents_1.Contents, {
    pattern: pattern,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    label: label,
    scale: scale,
    iconScale: iconScale,
    isInverse: isInverse
  })) : react_1.default.createElement(root_1.Root, {
    className: rootClasses,
    "data-testid": testID,
    role: "link",
    isInverse: isInverse,
    pattern: pattern,
    onClick: onClick,
    disabled: isDisabled,
    "aria-disabled": isDisabled
  }, react_1.default.createElement(contents_1.Contents, {
    pattern: pattern,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    label: label,
    scale: scale,
    iconScale: iconScale,
    isInverse: isInverse
  })));
};

var LinkiconWithSpace = (0, ui_helper_with_space_1.withSpace)(Linkicon);
exports.Linkicon = LinkiconWithSpace;